import {
    RETRIEVE_PAYOUTS,
    RETRIEVE_HOST_PAYOUTS
} from "../actions/types";
  
  const initialState = { payouts : [], totalPayoutCount : 0 };

const payoutReducer = (state = initialState, action) => {
  const { type, payload } = action;

  switch (type) {

    case RETRIEVE_PAYOUTS:
      return {
        payouts: payload.rows,
        totalPayoutCount: payload.count,
      };

    case RETRIEVE_HOST_PAYOUTS:
      return {
        payouts: payload.rows,
        totalPayoutCount: payload.count,
      };
      
    default:
      return state;
  }
};

export default payoutReducer;